import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent {
  @Input() estado: boolean;
  @Input() id: any;
  @Output() clickEnable = new EventEmitter<any>();
}
